export default {
  color: "red",
};
